import React from 'react';

export const DropboxSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-67.5"
				y="-23.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<rect width="32" height="32" rx="8" fill="#0061FF" />
			<path
				d="M16.0129 10.9983L10.9891 14.2031L16.0129 17.4079L10.9891 20.6128L5.96533 17.3906L10.9891 14.1858L5.96533 10.9983L10.9891 7.79346L16.0129 10.9983ZM10.9631 21.6435L15.9869 18.4387L21.0107 21.6435L15.9869 24.8483L10.9631 21.6435ZM16.0129 17.3906L21.0367 14.1858L16.0129 10.9983L21.0107 7.79346L26.0345 10.9983L21.0107 14.2031L26.0345 17.4079L21.0107 20.6128L16.0129 17.3906Z"
				fill="white"
			/>
		</svg>
	);
};
